'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _downloads = require('helpers/downloads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _playlist = require('redux/modules/playlist');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _auth = require('redux/modules/auth');

var _responseCodes = require('helpers/responseCodes');

var _LoginDialog = require('containers/LoginDialog/LoginDialog');

var _LoginDialog2 = _interopRequireDefault(_LoginDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var isAuthRequireCode = function isAuthRequireCode(code) {
  return [_responseCodes.downloadTracksCodes.needLogin, _responseCodes.downloadTracksCodes.requireAuth].includes(code);
};

var Download = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    downloadFileFromKeyCode: state.playlist.downloadFileFromKeyCode,
    downloadKey: ownProps.location.query.key,
    user: state.auth.user
  };
}, { downloadFileFromKey: _playlist.downloadFileFromKey, setRedirect: _auth.setRedirect }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Download, _Component);

  function Download() {
    var _ref;

    (0, _classCallCheck3.default)(this, Download);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Download.__proto__ || (0, _getPrototypeOf2.default)(Download)).call.apply(_ref, [this].concat(args)));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Download, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.download();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var code = this.props.downloadFileFromKeyCode;
      if (!prevProps.user && this.props.user && isAuthRequireCode(code)) {
        this.download();
      }
    }
  }, {
    key: 'download',
    value: function download() {
      var _this2 = this;

      var _props = this.props,
          downloadKey = _props.downloadKey,
          user = _props.user;


      this.props.downloadFileFromKey(downloadKey).promise.then(function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            code = _ref2.code,
            msg = _ref2.msg,
            data = _ref2.data;

        if (isAuthRequireCode(code)) {
          if (!user) {
            _this2.props.setRedirect('/service/download?key=' + downloadKey);
            _this2.loginDialogEl.open();
          }
        } else if (code) {
          _toastr2.default.warning(msg);
        }
        var file = data.file;

        if (file) {
          (0, _downloads.download)('' + _config2.default.app.urlParts.audioArchive + file);
        }
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'bindDialog',
    value: function bindDialog(el) {
      if (el) {
        this.loginDialogEl = el.getWrappedInstance().getWrappedInstance();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          downloadFileFromKeyCode = _props2.downloadFileFromKeyCode,
          user = _props2.user;

      var isAuthRequired = isAuthRequireCode(downloadFileFromKeyCode) && !user;
      var isWrongUser = isAuthRequireCode(downloadFileFromKeyCode) && user;
      var loginMsg = t('Please login to download your content');

      return _react2.default.createElement(
        'div',
        { className: 'compactContent' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('Download') }),
        _react2.default.createElement(
          'h1',
          null,
          t('Downloading'),
          '...'
        ),
        isAuthRequired && _react2.default.createElement(
          'p',
          null,
          loginMsg
        ),
        isWrongUser && _react2.default.createElement(
          'p',
          { className: 'danger' },
          t('You don\'t have a permissions to download this file')
        ),
        !isAuthRequired && !isWrongUser && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            t('Your file should start downloading in just a moment.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('If your download doesn\'t start automatically'),
            _react2.default.createElement(
              'a',
              { className: 'margin-left-5 margin-right-5', onClick: this.download },
              t('click here')
            ),
            t('to get your file'),
            '.'
          )
        ),
        _react2.default.createElement(_LoginDialog2.default, { ref: this.bindDialog, hint: loginMsg })
      );
    }
  }]);
  return Download;
}(_react.Component), _class3.propTypes = {
  downloadFileFromKey: _propTypes2.default.func,
  downloadFileFromKeyCode: _propTypes2.default.number,
  downloadKey: _propTypes2.default.string,
  setRedirect: _propTypes2.default.func,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'download', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'download'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindDialog', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindDialog'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = Download;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Download/Download.js
// module id = 2155
// module chunks = 1